import React, { FC, ReactNode, useContext } from 'react';

import ColorSchemeContext from '../../colorScheme/ColorSchemeContext';

import CorpoSlogan from '../../corpo/CorpoSlogan';
import CorpoCopyright from '../../corpo/CorpoCopyright';

import FooterLinks, { FooterLinksProps } from '../FooterLinks';
import { StyledFooter, StyledFooterContainer, StyledFooterSlogan, StyledFooterCopyright, StyledInlineSloganWrapper, StyledInlineSloganButtonWrapper } from './MainFooter.styles';
import FooterLanguageButton from '../#FooterLanguageButton';

export interface MainFooterProps extends FooterLinksProps {
  /** Overrides the copyright text. */
  copyrightText?: ReactNode;
  /** Align the footer content with the layout content instead of the MainHeader. */
  alignWithContent?: boolean;
  /** Put the language button on the same row as the slogan */
  languageButtonInlineWithSlogan?: boolean;
}

const MainFooterDefaultProps = {
  alignWithContent: false,
};

/**
 * @since 0.18.0
 */
const MainFooter: FC<MainFooterProps> = ({
  copyrightText, alignWithContent, linksUrl, linksDomain, links, noLinksLoader, onLanguageChange, noLanguageButton, buttons, languageButtonInlineWithSlogan, ...props
}) => {
  const { scheme } = useContext(ColorSchemeContext);

  return (
    <StyledFooter
      scheme={scheme}
      data-testid="MainFooter"
      {...props}
    >
      <StyledFooterContainer alignWithContent={alignWithContent}>
        <FooterLinks
          linksUrl={linksUrl}
          linksDomain={linksDomain}
          links={links}
          noLinksLoader={noLinksLoader}
          onLanguageChange={onLanguageChange}
          noLanguageButton={noLanguageButton || languageButtonInlineWithSlogan}
          buttons={buttons}
        />
        {
          languageButtonInlineWithSlogan ?
            (
              <StyledInlineSloganWrapper>
                <StyledFooterSlogan data-testid="MainFooterSlogan"><CorpoSlogan /></StyledFooterSlogan>
                <StyledInlineSloganButtonWrapper>
                  <FooterLanguageButton onLanguageChange={onLanguageChange} />
                </StyledInlineSloganButtonWrapper>
              </StyledInlineSloganWrapper>
            ) :
            (
              <StyledFooterSlogan data-testid="MainFooterSlogan"><CorpoSlogan /></StyledFooterSlogan>
            )
        }
        <StyledFooterCopyright data-testid="MainFooterCopyright">{copyrightText || <CorpoCopyright />}</StyledFooterCopyright>
      </StyledFooterContainer>
    </StyledFooter>
  );
};

MainFooter.defaultProps = MainFooterDefaultProps;

export default MainFooter;
